import type { SxProps } from '@mui/material';

import { NO_PLACEHOLDER, YES_PLACEHOLDER } from '@occc-app/design-system/constants';

export const normaliseSx = (sx?: SxProps) => (Array.isArray(sx) ? sx : sx ? [sx] : []);

export const getLabelForTruthy = (value: unknown) => {
  return value ? YES_PLACEHOLDER : NO_PLACEHOLDER;
};
